import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getAccessToken } from '../lib/supabase';
import { getSupabaseUrl, getSupabaseAnonKey } from '../lib/environments';

export function LiveEventBanner() {
  const navigate = useNavigate();
  const { session } = useAuth();
  const [event, setEvent] = useState<{ id: string; name: string; isLive: boolean } | null>(null);

  useEffect(() => {
    if (!session) return;
    let cancelled = false;
    const check = async () => {
      try {
        const token = getAccessToken();
        if (!token) return;
        const res = await fetch(`${getSupabaseUrl()}/functions/v1/wall-api?action=my_event`, {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json', 'apikey': getSupabaseAnonKey() },
          body: '{}',
        });
        const data = await res.json();
        if (cancelled) return;
        if (data.has_event) {
          setEvent({ id: data.event_id, name: data.event_name, isLive: !!data.is_live });
        } else {
          setEvent(null);
        }
      } catch {}
    };
    check();
    const interval = setInterval(check, 30000);
    return () => { cancelled = true; clearInterval(interval); };
  }, [session]);

  if (!event) return null;

  return (
    <button
      onClick={() => navigate(`/events/${event.id}`)}
      className="w-full flex items-center justify-between px-4 py-3 bg-indigo-600 text-white hover:bg-indigo-500"
    >
      <span className="text-sm truncate">
        📺 <span className="font-semibold">{event.name}</span>{event.isLive ? ' is live' : ''}
      </span>
      <span className="text-sm font-semibold flex-shrink-0 ml-3">Enter →</span>
    </button>
  );
}
